// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__K04Qq","container":"Hero_container__vu2LQ","content":"Hero_content__I1OX4","blue":"Hero_blue__Ge1Qg"};